<mat-sidenav-container class="layout-container">
      @if (!hideSidebar()) {
        <mat-sidenav
          #sidenav
          [mode]="isMobile() ? 'over' : 'side'"
          [opened]="sidenavOpened()"
          class="layout-sidebar"
          fixedInViewport="false">
          <app-global-sidebar [menuItems]="menuConfig" (itemClick)="isMobile() && sidenav.close()"></app-global-sidebar>
        </mat-sidenav>
      }

      <mat-sidenav-content class="layout-content">
        <app-global-header moduleTitle="Asset Management" [showMenuToggle]="!hideSidebar()" (toggleSidebar)="toggleSidenav()"></app-global-header>

        <div class="main-content">
          <app-breadcrumb></app-breadcrumb>
          <div class="page-container">
            <router-outlet></router-outlet>
          </div>
        </div>
        <app-global-footer></app-global-footer>
</mat-sidenav-content>
    </mat-sidenav-container>